/* eslint-disable react/prop-types */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import uuid from 'uuid/v4';
import messages from './messages';

function Separator({ index, list }) {
  if (list.length === 0 || list.length - 1 === index) {
    return '';
  }
  if (list.length - 2 === index) {
    return (
      <span>
        {' '}
        <FormattedMessage {...messages.and} />
        {' '}
      </span>
    );
  }
  return <span>, </span>;
}

function NaturalList({ list, className }) {
  return list.map((i, index) => (
    <span key={uuid()} className={className}>
      {i}
      <Separator index={index} list={list} />
    </span>
  ));
}

export default NaturalList;
